import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const proceedToCheckout = createAction("".concat(stateName, "/proceedToCheckout"));